// NPM
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { omitBy, isNil, isEmpty} from 'lodash';

// VALIDATOR
import ChangePasswordFormSchema from './change-password.validation';

// UTIL
import errorHandler from 'Utils/error-handler';

// ANT COMPONENT
import { Space, Row, Col } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import { TextInput, AlertBox, Password, Button } from '@life-line-lab/components-react';

// HELPER
import { toaster } from 'Helpers/toaster';

// STYLE
import './change-password.scss';

interface PasswordProps {
    // data?: any;
    onSubmit: (currentPassword:string, newPassword:string) => void;
    // onCancel: () => void;
}

const PasswordForm: React.FC<PasswordProps> = ({ onSubmit }) => {
    const history = useHistory();

    const initialInput = {
        currentPassword:'',
        newPassword:'',
        confirmPassword:'',
    }

    const initialError = {}
    const { t } = useTranslation();

    const [input, setInput] = useState<any>(initialInput)
    const [error, setError] = useState<any>(initialError)

    const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setError(initialError);
        setInput({...input, [e.target.name]: e.target.value});
    }

    const handleSubmit = () => {
        try {
            const value = ChangePasswordFormSchema.validateSync(omitBy({
              ...input
            }, isNil), {
              strict: true,
              abortEarly: true,
              stripUnknown: false
            });
      
            if (!isEmpty(value))
              onSubmit(input.currentPassword, input.newPassword);
              
          }
          catch(err) {
            let { path, refPath, value } = errorHandler.validation(err) || {};
      
            if (!isNil(refPath)) {
              setError({
                ...error,
                [path]: t(`${value}`, {
                  field: t(`label.${path}`),
                  refPath: refPath ? t(`label.${refPath}`) : null
                })
              });
            }
            else {
              setError({
                ...error,
                [path]: t(`${value}`, { field: t(`label.${path}`) })
              });
            }
      
            if (document.querySelector(`input[name=${path}]`)) {
              (document.querySelector(`input[name=${path}]`) as HTMLInputElement).focus();
            }
            else if (document.querySelector(`div[name=${path}]`)) {
              (document.querySelector(`div[name=${path}] input`) as HTMLInputElement).focus();
            }
          }
     
    }
    return (
        <div className="password-form">
            <h4 className="title" > </h4>
            <Row >
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <Password
                    placeholder={t("txt.currentPassword")}
                    isRequired={true}
                    className="text-input"
                    label={t('label.currentPassword')}
                    name="currentPassword"
                    value={input.currentPassword}
                    onChange={(event)=>handleTextChange(event)}/>
                <AlertBox text={error.currentPassword} />
                <Password
                    placeholder={t("txt.newPassword")}
                    className="text-input"
                    isRequired={true}
                    label={t('label.newPassword')}
                    name="newPassword"
                    value={input.newPassword}
                    onChange={(event)=>handleTextChange(event)}/>
                <AlertBox text={error.newPassword} />

                <Password
                    placeholder={t("txt.confirmNewPassword")}
                    isRequired={true}
                    className="text-input"
                    label={t('label.confirmNewPassword')}
                    name="confirmPassword"
                    value={input.confirmPassword}
                    onChange={(event)=>handleTextChange(event)}/>
                <AlertBox text={error.confirmPassword} />
                <div>
          {/* <span>{t('txt.passwordFormat')}</span> */}
                    <Space direction="vertical" size="small" style={{paddingTop:"20px"}}>
                    <span> - {t('txt.minimumSixCharacters')}</span>
                    <span> - {t('txt.maximumTwelveCharacters')}</span>
                    <span dangerouslySetInnerHTML={{ __html: ` - ${t('txt.alphanumeric')}` }}/>
                    </Space>
                </div>
                </Col>
            </Row>
            <Row>
                <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                    <Button
                        className="button--left"
                        type="primary"
                        label={t('action.submit')}
                        size="small"
                        onClick={handleSubmit}
                    />

                    {/* <Button
                        className="button--right cancel"
                        type="primary"
                        label={t('action.cancel')}
                        size="small"
                        onClick={handleCancel}
                    /> */}

                </Col>
            </Row>
        </div>
    )
}
export default PasswordForm
